// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:992px){.buy-sell-control__total[data-v-53c69447]{width:100%}}.buy-sell-control__percentage[data-v-53c69447]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
